const translations = {
  "en": {
    "Add manually": "Add manually",
    "Change another checkup": "Change another checkup",
    "Connect account": "Connect account",
    "Connect an account to run portfolio checkup": "Connect an account to run portfolio checkup",
    "This checkup reads your real holdings. Connect one and I'll run it.": "This checkup reads your real holdings. Connect one and I'll run it."
  },
  "zh-tw": {
    "Add manually": "手動新增",
    "Change another checkup": "變更另一次檢查",
    "Connect account": "連結帳戶",
    "Connect an account to run portfolio checkup": "連接帳戶以執行投資組合檢查",
    "This checkup reads your real holdings. Connect one and I'll run it.": "此檢測將讀取你的實際持倉。連接一項，我將為你執行檢測。"
  }
};

export default translations;
